export default __webpack_public_path__ + "static/media/program-5.b1edfafb.jpg";